module.exports = __webpack_public_path__ + "media/typy/budowlane@2x-18031cb1.png";